// Importing main deendencies
import Vue from 'vue'
import Router from 'vue-router'
import Resource from 'vue-resource'
import NProgress from 'nprogress'
import Moment from 'moment'
import './transitions'
import _ from 'lodash'

import FooterBar from "./components/layout/FooterBar.vue"
import Navbar from "./components/layout/Navbar.vue"

import Vuetable from 'vuetable/src/components/Vuetable.vue';
import VuetablePagination from 'vuetable/src/components/VuetablePagination.vue';
import VuetablePaginationDropdown from 'vuetable/src/components/VuetablePaginationDropdown.vue';

// you need to declar the component
import Hello from "./components/Hello.vue"
import ListOffers from "./components/offers/list-offers.vue"
import CreateEditOffers from "./components/offers/create-edit-offers.vue"
import OffersInformation from "./components/offers/offers-information.vue"
import ClientOffers from "./components/offers/client-offers.vue"
import ClientOffersGym from "./components/offers/client-offers-gyms.vue"
import ClientOffersPaid from "./components/offers/client-offers-pagatodo.vue"
import ApplyOffer from "./components/offers/apply-offer.vue"
import ListProducts from "./components/offers/list-products.vue"
import OfferClientsInfo from "./components/offers/offers-clients-info.vue"
import ClientOffersAll from "./components/offers/client-offers-all.vue"
import DashboardOffers from "./components/layout/dashboard-offers.vue"
import DevicesList from "./components/layout/devices-list.vue"
import ProductDetailDevices from "./components/layout/product-detail.vue"
import ProductDetails from "./components/layout/product-details.vue"
import HomeOffers from "./components/layout/home-offers.vue"
import BrandList from "./components/layout/brand-list.vue"
import ByProvider from "./components/layout/by-provider.vue"
import TypesOfBrands from "./components/layout/types-of-brands.vue"
import SearchCategories from "./components/layout/elements/search-categories.vue"
import HeaderDashboard from "./components/layout/elements/header-dashboard.vue"

import devicesScreen from "./components/layout/device-mobile-types-offers.vue"
import hotelsScreen from "./components/layout/hotel-offers.vue"
import servicesScreen from "./components/offers/services.vue"
import checkoutScreen from "./components/layout/checkout-screen.vue"
import createOffer from "./components/layout/create-offer.vue"
import editOffer from "./components/layout/edit-offer.vue"
import productDetailSpecs from "./components/offers/product-detail-specs.vue"
import greenDragger from "./components/offers/green-dragger.vue"


// promotions
import promotion from "./components/promotion/index.vue"
import promotionCreate from "./components/promotion/create.vue"
import promotionEdit from "./components/promotion/create.vue"

// brands
import brands from "./components/brands/index.vue"
import brandsCreate from "./components/brands/create.vue"
import brandsEdit from "./components/brands/create.vue"

// FontAwesome Icon
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faChevronLeft, faChevronRight, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// library.add(faChevronLeft)
// library.add(faChevronRight)
// library.add(faCheckCircle)

// Importing components
Vue.use(Router)
Vue.use(Resource)

// Create components for the marketplace
Vue.component('vuetable', Vuetable);
Vue.component('vuetable-pagination', VuetablePagination);
Vue.component('vuetable-pagination-dropdown', VuetablePaginationDropdown);
Vue.component('create-edit-offers', CreateEditOffers);
Vue.component('product-detail-specs', productDetailSpecs);
Vue.component('green-dragger', greenDragger);
// Vue.component('font-awesome-icon', FontAwesomeIcon)

window.moment = Moment;

// Layout
var App = Vue.extend({
  components: {
    Hello, //add it to the component list for the app
    ListOffers,
    OffersInformation,
    ClientOffers,
    ApplyOffer,
    ListProducts,
    ClientOffersAll,
  },
})
// Initiallizing router
const router = new Router({
  saveScrollPosition: true,
  linkActiveClass: 'is-active'
})

// Configuring loading bar
Vue.http.interceptors.push((request, next) => {
  NProgress.inc(0.2)

  next((response) => {
    NProgress.done()
    return response
  })
})

router.beforeEach(({ next }) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

var lazyLoading = function (path, ext = '.vue') {
  return require(`${path}${ext}`)
}

// this is where you declare the component for the router if you need to add naother just add it here
// component: DashboardOffers
router.map({
  '/': {
    name: 'DashboardOffers',
    component: HomeOffers
  },
  '/administrator/offers': {
    name: 'administrator-offers', //index (admin)
    component: lazyLoading('./components/offers/list-offers')
  },
  '/administrator/provider': {
    name: 'administrator-provider',
    component: lazyLoading('./components/provider/list')
  },
  '/administrator/orders': {
    name: 'administrator-orders',
    component: lazyLoading('./components/orders/index')
  },
  '/administrator/services': {
    name: 'administrator-orders',
    component: lazyLoading('./components/orders/services')
  },
  '/administrator/comments': {
    name: 'comments',
    component: lazyLoading('./components/offers/comments')
  },
  '/administrator/provider/:id': {
    name: 'administrator-provider-edit',
    component: lazyLoading('./components/provider/edit')
  },
  '/create-provider': {
    name: 'create-provider',
    component: lazyLoading('./components/provider/create')
  },
  '/list-products/:id': {
    name: 'list-products',
    component: lazyLoading('./components/offers/list-products')
  },
  '/offers/:id/information': {
    name: 'offers-information', //offer info (admin)
    component: lazyLoading('./components/offers/offers-information')
  },
  '/client-offers': {
    name: 'client-offers', //listado de ofertas para el cliente (client)
    component: lazyLoading('./components/offers/client-offers')
  },
  '/client-offers/:id': {
    name: 'client-offers', //listado de ofertas para el cliente (client)
    component: lazyLoading('./components/offers/client-offers')
  },
  '/new-client-offers/:id': {
    name: 'new-client-offers', //listado de ofertas para el cliente (client)
    component: lazyLoading('./components/offers/offers-information-new')
  },
  '/client-offers-all/:service_id/:id': {
    name: 'client-offers-all', //listado de ofertas para el cliente (client)
    component: lazyLoading('./components/offers/new-board')
  },
  '/apply-offer/:id': {
    name: 'apply-offer', //solictar offerta para el empleado (call center)
    component: lazyLoading('./components/offers/apply-offer')
  },
  '/offers/:id/information/:companyId': {
    name: 'purchased-offers', //offer client info (admin)
    component: lazyLoading('./components/offers/offers-clients-info')
  },
  '/dashboard-offers': {
    name: 'DashboardOffers',
    component: HomeOffers
  },
  '/devices-list': {
    name: 'DevicesList',
    component: DevicesList
  },
  '/product-detail/:id': {
    name: 'ProductDetail',
    component: ProductDetailDevices
  },
  '/product-details/:id': {
    name: 'ProductDetails',
    component: ProductDetails
  },
  '/device-types': {
    name: 'mobile-device-types',
    component: devicesScreen
  },
  '/hotels': {
    name: 'hotels',
    component: hotelsScreen
  },
  '/services/:id': {
    name: 'services',
    component: servicesScreen
  },
  '/offers/:id/checkout': {
    name: 'product-checkout',
    component: checkoutScreen
  },
  '/create-offer': {
    name: 'create-offer',
    component: createOffer
  },
  '/edit-offer/:id': {
    name: 'edit-offer',
    component: editOffer
  },
  '/home-offers': { // Home Offers
    name: 'home-offers',
    component: HomeOffers
  },
  '/brand-list/:id': { // Brand List
    name: 'brand-list',
    component: BrandList
  },
  '/types-of-brands/:id': { // Devices Categoty List
    name: 'types-of-brands',
    component: TypesOfBrands
  },
  '/by-provider/:id': {
    name: 'by-provider',
    component: ByProvider
  },
  '/administrator/promotion': {
    name: 'promotion',
    component: promotion
  },
  '/administrator/promotion/create': {
    name: 'promotionCreate',
    component: promotionCreate
  },
  '/administrator/promotion/:id': {
    name: 'promotionEdit',
    component: promotionEdit
  },
  '/administrator/brands': {
    name: 'brands',
    component: brands
  },
  '/administrator/brands/create': {
    name: 'brandsCreate',
    component: brandsCreate
  },
  '/administrator/brands/:id': {
    name: 'brandsEdit',
    component: brandsEdit
  },
});

router.start(App, '#app')


// WEBPACK FOOTER //
// ./src/main.js